/** Fold accents and case for accent-insensitive substring search. */
export function foldForSearch(value: string | null | undefined): string {
  if (!value) return ''
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
}
